module.exports = __webpack_public_path__ + "img/paypal-logo.75e8f630.svg";